import { List } from 'immutable';
import { isValidQuery } from 'customer-data-objects/search/ElasticSearchQuery';
import { makeOperator } from './Operator';
export default makeOperator({
  name: 'NotWildCardEqual',
  values: [{
    name: 'value',
    defaultValue: List(),
    isValid: value => List.isList(value) && !value.isEmpty() && value.every(isValidQuery)
  }]
});